import { useEffect, useMemo, useRef, useState } from "react";
import { ChangeAlertCallbackType } from "../../../Root";
import { CustomerService } from "../../../../services/CustomerService";
import { MenuItem, Select } from "@mui/material";
import moment from "moment";
moment.locale("es");

export const useVipTable = (changeAlert: ChangeAlertCallbackType) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [tabActive, setTabActive] = useState("worker");
    const customerService = useRef<CustomerService>();

    const [page, setPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [totalDocuments, setTotalDocuments] = useState(0);

    const tabs = [
        { key: "worker", title: "Workers" },
        { key: "customer", title: "Clientes" },
    ];

    const validation = [
        { key: "default", label: "Por validar" },
        { key: "allowed", label: "Permitir Cancelación" },
        { key: "denied", label: "NO Permitir Cancelación" },
    ];

    const saveData = async (result) => {
        setLoading(true);
        setData(result.content);
        setTotalDocuments(result.pagination["total_documents"] || 0);

        setLoading(false);
    };

    const changeTab = (tab: string) => {
        setTabActive(tab);
        getData(tab);
    };
    const changePage = (action, page, rows = rowsPerPage) => {
        setPage(page + 1);
        getData(page + 1, rows);
    };
    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setRowsPerPage(JSON.parse(JSON.stringify(event.target.value)));
        changePage(null, 0, parseInt(event.target.value, 10));
    };

    const getData = async (tab = tabActive, rows = rowsPerPage) => {
        setLoading(true);
        let data = {
            filters: {
                active: true,
                type: tab
            },
            pagination: {
                page_number: 1,
                results_per_page: rows,
            },
        };

        const response = await customerService.current.customerVipList(data);
        saveData(response.data?.widget[0].data);
        setLoading(false);
    };

    const onHandleChange = async (uuid , e ) => {
        setLoading(true);
        let data = {
            filters: {
                uuid: uuid
            },
            data: {
                validation: e.target.value
            }
        };

        const response = await customerService.current.customerVipUpdate(data);
        if (response['data']?.response === 'OK') {
            changeAlert(true, 'success', 'Estatus de validación actualizado con éxito.');
            getData();
        } else {
            setLoading(false);
            changeAlert(true, 'error', response['message'] || response['data'].message || 'Error al actualizar el estatus');
        }
    };

    const onHandleSearch = async ({value, type}) => {
        setLoading(true);
        let data = {
            filters: {
                type: tabActive,
                searchType: type,
                keyword: value,

            },
            pagination: {
                page_number: 1,
                results_per_page: rowsPerPage,
            }
        };

        const response = await customerService.current.customerVipFind(data);
        if (response['data']?.response === 'OK') {
            saveData(response.data);
            setLoading(false);
        } else {
            setLoading(false);
            changeAlert(true, 'error', response['message'] || response['data'].message || 'Error al realizar búsqueda');
        }
    };

    useEffect(() => {
        customerService.current = new CustomerService(changeAlert);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const calculateColumns = useMemo(() => {
        const columns = [
        ];
        columns.push(
            { selector: (row) => row["customer"]["uuid"], name: "UUID", wrap: true, sortable: true },
            { selector: (row) => row["customer"]["email"], name: "Correo", wrap: true, sortable: true },
            { selector: (row) => row["customer"]["phone"], name: "Teléfono", wrap: true, sortable: true, width: "12%" },
            { selector: (row) => row["customer"]["taxid"], name: "RFC", wrap: true, sortable: true, width: "13%" },
            { selector: (row) => row.active ? 'Activo' : 'Inactivo', name: "Estatus", wrap: true, sortable: true, width: "10%" },
            { selector: (row) => moment(row.cdate).format("L"), name: "Fecha creación", wrap: true, sortable: true, width: "10%" },
        );
        if(tabActive === "customer"){
            columns.push(
                { cell: (row) => (
                        <Select value={row["validation"] || -1} onChange={onHandleChange.bind(this, row.uuid)} color="secondary" MenuProps={{ style: { zIndex: 35001 } }} variant="standard" fullWidth>
                            <MenuItem value={-1} disabled>Seleccione</MenuItem>
                            {validation.map((i) => (
                                <MenuItem key={`validation-${i.key}`} value={i.key}>
                                    {i.label}
                                </MenuItem>
                            ))}
                        </Select>
                    ), name: "Acciones", wrap: true, sortable: true, width: "15%"
                },
            );
        }
        return columns;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabActive]);
    
    return {
        columns: calculateColumns,
        data,
        loading,
        tabActive,
        tabs,
        pagination: { page, rowsPerPage, totalDocuments },
        changeTab,
        saveData,
        getData,
        changePage,
        handleChangeRowsPerPage,
        onHandleSearch
    };
};
